<div class="dropdown" [class.dropdown_opened]="dropdownOpened">
  <ng-content select="[dropdown-item]"></ng-content>
</div>
